import {
  MockMap,
} from '@ama-sdk/core';
import {
  createMockData,
} from '@dapi/sdk/spec';
import {
  acknowledgeSuccess,
  alternativeOfferConfirmationJobMock,
  alternativeOfferInProgressJobMock,
  getAlternativeOffersMockDisruptedOutboundForLostServices,
  retrieveOrderMockDisruptedOutboundWithLostServices,
} from '../../../mock/data/index';

export const disruptedOutboundWithLostServicesMock: MockMap = {
  retrieveOrder: [
    {
      mockData: retrieveOrderMockDisruptedOutboundWithLostServices
    }
  ],
  getOrderEligibilities: [],
  getAlternativeOffers: [
    {
      mockData: getAlternativeOffersMockDisruptedOutboundForLostServices
    }
  ],
  createAsynchronousJobForAlternativeOfferConfirmation: [createMockData(alternativeOfferInProgressJobMock)],
  getAlternativeOfferConfirmationJob: [createMockData(alternativeOfferConfirmationJobMock)],
  acknowledge: [createMockData(acknowledgeSuccess)]
};
